export default {
  tip: 'explanation'
}

